import React from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n/LanguageContext';
import siteImageManifest from '../data/siteImageManifest.generated.json';

export default function CustomMold() {
  const { t } = useI18n();
  const v = typeof siteImageManifest?.generatedAt === 'string' ? siteImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';
  const heroImageSrc = `${process.env.PUBLIC_URL}/images/altele/mat_pers.png${suffix}`;
  const heroLines = t('customMold.heroLines');
  const bullets = t('customMold.bullets');

  return (
    <section className="yk-page yk-customMoldPage">
      <div className="yk-customMoldHero">
        <div className="yk-customMoldHeroLeft">
          <h1 className="yk-customMoldHeroTitle">
            {Array.isArray(heroLines)
              ? heroLines.map((line) => (
                  <span key={line} className="yk-customMoldHeroTitleLine">
                    {line}
                  </span>
                ))
              : t('customMold.title')}
          </h1>
        </div>

        <div className="yk-customMoldHeroRight" aria-hidden="true">
          <div className="yk-customMoldHeroMedia">
            <img className="yk-customMoldHeroImage" src={heroImageSrc} alt="" loading="lazy" />
          </div>
        </div>
      </div>

      <div className="yk-card yk-customMoldInfo">
        <p className="yk-customMoldInfoLead">
          <span>{t('customMold.infoLeadPrefix')} </span>
          <strong>{t('customMold.infoLeadStrong')}</strong>
          <span>{t('customMold.infoLeadSuffix')}</span>
        </p>

        {Array.isArray(bullets) && bullets.length ? (
          <ul className="yk-customMoldList">
            {bullets.map((item) => (
              <li key={item} className="yk-customMoldListItem">
                <span className="yk-customMoldCheck" aria-hidden="true">
                  ✓
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        ) : null}

        <p className="yk-customMoldInfoBottom">{t('customMold.bottomLine')}</p>

        <NavLink to="/contact" className="yk-btn yk-btnPrimary">
          {t('customMold.cta')}
        </NavLink>
      </div>
    </section>
  );
}
